import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/languex-app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/global-components/credentials-strip/CredentialsStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/excellence/Excellence.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/global-components/trust-strip/TrustStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/services/components/LanguexExcellence/LanguexExcellence.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesDocuments/ServicesDocuments.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesEnsureCompliance/ServicesEnsureCompliance.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesFAQ/ServicesFAQ.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesHero/ServicesHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesHeroQuality/ServicesHeroQuality.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesIndustry/ServicesIndustry.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesIndustryCards/ServicesIndustryCards.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesLanguages/ServicesLanguages.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesProcessWork/ServicesProcessWork.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesPromises/ServicesPromises.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesResources/ServicesResources.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesTranslationPrompt/ServicesTranslationPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesTrust/ServicesTrust.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesTrustedExpertise/ServicesTrustedExpertise.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/services/components/ServicesUseCases/ServicesUseCases.tsx");
